if (!customElements.get("predictive-search")) {
  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();

      this.predictiveSearchInput = this.querySelector(
        ".predictive-search__input"
      );
      this.predictiveSearchInput.addEventListener(
        "input",
        this._onChange.bind(this)
      );

      this.predictiveSearchInputClear = this.querySelector(
        ".predictive-search__input-clear"
      );
      this.predictiveSearchInputClear.addEventListener(
        "click",
        this._handleInputClear.bind(this)
      );

      this.predictiveSearchBody = this.querySelector(
        ".predictive-search-drawer__body"
      );

      this.predictiveSearchDrawerTrigger = this.querySelector(
        ".predictive-search__mobile-trigger"
      );
      this.predictiveSearchDrawer = this.querySelector(
        ".predictive-search-drawer"
      );
      this.drawerClose = this.querySelector(".drawer__close");

      this.predictiveSearchSuggestedTerm = this.querySelectorAll(
        ".predictive-search__suggested-term"
      ).forEach((suggestedTerm) => {
        suggestedTerm.addEventListener(
          "click",
          this._handleSuggestedTermClick.bind(this)
        );
      });

      this.predictiveSearchSections = this.querySelectorAll(
        ".predictive-search__section"
      );

      this.suggestions = this.querySelector(".suggestions");
      this.featuredProducts = this.querySelector(".featured-products");
      this.searchResults = this.querySelector(".search-results");
      this.searchResultsNumber = this.querySelector(".number-of-results");
      this.searchResultsGrid = this.searchResults.querySelector(".grid");

      this.debouncedGetResults = debounce((e) => {
        this._getSearchResults(e);
      }, 500);

      this.predictiveSearchDrawerTrigger.addEventListener(
        "click",
        this._handleDrawerTriggerClick.bind(this)
      );

      this.drawerClose.addEventListener(
        "click",
        this._handleDrawerClose.bind(this)
      );

      this.predictiveSearchInput.addEventListener(
        "focus",
        this._onFocus.bind(this)
      );
      this.predictiveSearchInput.addEventListener(
        "blur",
        this._onBlur.bind(this)
      );

      this.predictiveSearchBody.addEventListener("change", (e) => {});

      window.addEventListener("click", this._handleClickOutside.bind(this));
    }

    _handleClickOutside(e) {
      if (
        this.querySelector(".display-for-desktop") &&
        !this.contains(e.target)
      ) {
        this.predictiveSearchInput.value = "";

        this.searchResults.classList.add("hidden");
        this.featuredProducts.classList.remove("hidden");
        this.suggestions.classList.remove("hidden");

        this.predictiveSearchInputClear.classList.add("hidden");
        this.querySelector(".display-for-desktop").classList.remove(
          "display-for-desktop"
        );
      }
    }

    _onFocus(e) {
      this.predictiveSearchBody.classList.add("display-for-desktop");
    }

    _onBlur(e) {
      // this.predictiveSearchBody.classList.remove("display-for-desktop");
    }

    _handleDrawerTriggerClick(e) {
      e.preventDefault();
      if (this.predictiveSearchDrawer.classList.contains("drawer--out-right")) {
        this.predictiveSearchDrawer.classList.replace(
          "drawer--out-right",
          "drawer--in-right"
        );
      } else {
        this.predictiveSearchDrawer.classList.add("drawer--in-right");
      }
    }

    _handleDrawerClose(e) {
      e.preventDefault();
      this.predictiveSearchDrawer.classList.replace(
        "drawer--in-right",
        "drawer--out-right"
      );
    }

    _handleSuggestedTermClick(e) {
      e.preventDefault();
      this.predictiveSearchInput.value = e.target.name.trim();
      this.predictiveSearchInput.dispatchEvent(new Event("input"));
    }

    _handleInputClear(e) {
      e.preventDefault();
      this.predictiveSearchInput.value = "";
      this.predictiveSearchInputClear.classList.add("hidden");
      this.predictiveSearchInput.dispatchEvent(new Event("input"));
      this.searchResultsGrid.innerHTML = "";
      this.searchResultsNumber.innerHTML = "";
    }

    _onChange(e) {
      e.preventDefault();

      this.searchResultsNumber.innerHTML = "";

      if (e.target.value.length === 0) {
        this.predictiveSearchInputClear.classList.add("hidden");
      }

      if (e.target.value.length > 3) {
        this.predictiveSearchInputClear.classList.remove("hidden");

        this.suggestions.classList.add("hidden");
        this.featuredProducts.classList.add("hidden");
        this.searchResults.classList.remove("hidden");

        const searchTerm = this.predictiveSearchInput.value;
        this.debouncedGetResults(searchTerm);
      } else {
        this.suggestions.classList.remove("hidden");
        this.featuredProducts.classList.remove("hidden");
        this.searchResults.classList.add("hidden");
      }
    }

    _getSearchResults(searchTerm) {
      const queryKey = searchTerm.replace(" ", "-").toLowerCase();

      fetch(
        `/search/suggest?q=${queryKey}&resources[type]=product&resources[limit]=12&resources[options][fields]=title,product_type,tag,variants.title,vendor,body`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: `application/json`,
          },
        }
      )
        .then((response) => {
          if (!response.ok) {
            var error = new Error(response.status);
            this.close();
            throw error;
          }

          return response.text();
        })
        .then((text) => {
          const response = JSON.parse(text);
          const products = response.resources.results.products;

          this.searchResultsGrid.innerHTML = "";
          this.searchResultsNumber.innerHTML = `${response.resources.results.products.length}`;

          products.forEach((product) => {
            const template = `
              <div class="flex flex-col">
                <a class="mb-2" href="${product.url}" title="${product.title}" data-turbo-action="replace">
                  <div class="relative bg-lightGray flex flex-row items-center justify-center aspect-square">
                    <img class="w-auto h-[140px]" loading="lazy" src="${product.image}" width="auto" height="140" alt="${product.title}">
                  </div>
                </a>
                <div class="flex flex-row">
                  <div class="text-softBlack font-themedium text-xs leading-4">
                    ${product.title}
                  </div>
                  
                </div>
              </div>
            `;

            this.searchResultsGrid.innerHTML += template;
          });
        })
        .catch((error) => {
          throw error;
        });
    }

    connectedCallback() {}
  }

  customElements.define("predictive-search", PredictiveSearch);
}
